import React from "react";

interface ServiceTitanIconProps {
  className?: string;
}

const ServiceTitanIcon: React.FC<ServiceTitanIconProps> = ({ className }) => (
  <svg
    className={className}
    fill="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13 2L4.5 13.5H11l-1 8.5L19.5 10H13z" />
  </svg>
);

export default ServiceTitanIcon;
